import React, { useState, useEffect, useCallback } from "react";
import { toast } from "react-toastify";
import { Form } from "react-bootstrap";
import Swal from "sweetalert2";
import Title from "designs/v1/components/Title";
import Button from "designs/v1/components/Button";
import {
  getPrimaryBankApi,
  updatePrimaryBankApi,
  getRequestTypeStage,
  getRequestTypeDocs,
} from "designs/v1/pages/ModifyKyc/services";

const UpdatePrimaryBank = ({
  stageScreen,
  setStageScreen,
  setStep,
  isContinue,
  setIsContinue,
  isLoading,
  setIsLoading,
  activeUserDetail,
}) => {
  const [bankList, setBankList] = useState([]);
  const [selectedBank, setSelectedBank] = useState(null);

  const loadBankDetalis = useCallback(async () => {
    setIsLoading(true);
    const payload = {
      request_type: stageScreen,
      doc_name: localStorage.getItem("BankRequestNumber"),
    };
    try {
      const resp = await getPrimaryBankApi(payload);
      const data = (resp.data?.data?.modification_details || []).filter(
        (item) => item.verified_bank_account === 1
      );
      setBankList(data.map((y) => ({ ...y, is_primary: 0 })));
      setSelectedBank({ name: data[0]?.name, is_primary: 0 });
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.log("error", error);
    }
  }, [setIsLoading, stageScreen]);

  useEffect(() => {
    loadBankDetalis();
  }, [loadBankDetalis]);

  const handleChange = (e, item) => {
    const checked = e.target.checked;
    const newList = bankList.map((y) =>
      y.name === item.name ? { ...y, is_primary: checked ? 1 : 0 } : y
    );
    setBankList(newList);
    setSelectedBank(newList.filter((y) => y.name === item.name)?.[0]);
  };
  const onSubmit = async () => {
    setIsLoading(true);
    const payload = {
      request_type: stageScreen,
      doc_name: localStorage.getItem("BankRequestNumber"),
      name: selectedBank?.name,
      is_primary: selectedBank?.is_primary,
    };
    console.log("payload", payload);
    try {
      const resp = await updatePrimaryBankApi(payload);
      console.log("resp", resp);
      setIsLoading(false);
      setIsContinue(false);
      const requestTypes = getRequestTypeStage();
      const requestTypesDocs = getRequestTypeDocs() || [];
      requestTypesDocs.push(payload.doc_name);
      if (requestTypes && requestTypes.length > 0) {
        requestTypes.shift();
        localStorage.setItem("RequestTypeStage", JSON.stringify(requestTypes));
        localStorage.setItem(
          "RequestTypeDocs",
          JSON.stringify(requestTypesDocs)
        );
        Swal.fire({
          title: "Bank Modification Request Saved. Thank You..!",
          icon: "success",
          showCloseButton: false,
          showConfirmButton: false,
          timer: 3000,
        });
        if (requestTypes.length === 0) {
          setTimeout(async () => {
            await setStageScreen("MultipleRequestTypes");
          }, 3000);
          return;
        }
        setTimeout(async () => {
          await setStageScreen(requestTypes[0]);
        }, 3000);
        return;
      }
      setStep("BankModificationReview");
    } catch (error) {
      setIsLoading(false);
      const { data } = error.response || {};
      toast.error(
        data.message?.message || "Internal server error!"
      );
    }
  };
  return (
    <div>
      <Title title="Bank Details" />
      <div className="col-md-12 mt-3">
        <div className="ml-2">
          <div>
            {bankList?.length > 0 ? (
              <div className="row mt-2">
                <div className="row mt-2">
                  <h6 className="col-sm">Account Type</h6>
                  <h6 className="col-sm">{bankList[0]?.account_type || "-"}</h6>
                </div>
                <div className="row mt-2">
                  <h6 className="col-sm">Full Name</h6>
                  <h6 className="col-sm">
                    {bankList[0]?.registered_name || "-"}
                  </h6>
                </div>
                <div className="row mt-2">
                  <h6 className="col-sm">Account Number</h6>
                  <h6 className="col-sm">
                    {bankList[0]?.verified_account_number || "-"}
                  </h6>
                </div>
                <div className="row mt-2">
                  <h6 className="col-sm">Bank Name</h6>
                  <h6 className="col-sm">
                    {bankList[0]?.verified_bank_name || "-"}
                  </h6>
                </div>
                <div className="row mt-2">
                  <h6 className="col-sm">Branch</h6>
                  <h6 className="col-sm">
                    {bankList[0]?.verified_branch || "-"}
                  </h6>
                </div>
                <div className="row mt-2">
                  <h6 className="col-sm">IFSC Code</h6>
                  <h6 className="col-sm">
                    {bankList[0]?.verified_ifsc || "-"}
                  </h6>
                </div>
                <div className="row mt-2">
                  <h6 className="col-sm">
                    Do you want as a primary bank or not
                  </h6>
                  <h6 className="col-sm">
                    <Form.Switch
                      label={bankList[0]?.is_primary === 1 ? "YES" : "NO"}
                      checked={bankList[0]?.is_primary === 1}
                      onChange={(e) => handleChange(e, bankList[0])}
                      className="inherit"
                    />
                  </h6>
                </div>
                {/* <table className="table mx-2">
                  <thead>
                    <tr>
                      <th scope="col">Name</th>
                      <th scope="col">Account Type</th>
                      <th scope="col">Account Number</th>
                      <th scope="col">Bank Name</th>
                      <th scope="col">Branch</th>
                      <th scope="col">IFSC Code</th>
                      <th scope="col">MICR Code</th>
                      <th scope="col">Primary Bank</th>
                    </tr>
                  </thead>
                  <tbody>
                    {bankList.map((item) => {
                      return (
                        <tr key={item.name}>
                          <td>{item.registered_name}</td>
                          <td>{item.account_type || "-"}</td>
                          <td>{item.verified_account_number}</td>
                          <td>{item.verified_bank_name}</td>
                          <td>{item.verified_branch}</td>
                          <td>{item.verified_ifsc}</td>
                          <td>{item.verified_micr_code || "-"}</td>
                          <td>
                            <input
                              type="checkbox"
                              value={item.is_primary}
                              checked={item.is_primary === 1}
                              onChange={(e) => handleChange(e, item)}
                            ></input>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table> */}
              </div>
            ) : (
              <h3>No Bank Details Found.</h3>
            )}
          </div>
          {!isLoading && (
            <div className="d-flex mt-4">
              <div className="ml-2">
                <Button
                  title="Back"
                  type="button"
                  handleClick={() => {
                    setStep(isContinue ? "CheckPrevRequest" : "CreateRequest");
                    setIsContinue(false);
                  }}
                  loading={isLoading}
                />
              </div>
              <div className="mx-2">
                <Button
                  title="Update Bank Details"
                  handleClick={() => onSubmit()}
                  loading={isLoading}
                />
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default UpdatePrimaryBank;
